import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformXDRPage from '@src/pages/Platform/XDR';

export const Route = createLazyFileRoute('/platform/xdr')({
  component: PlatformXDRPageWithLayout,
});

function PlatformXDRPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformXDRPage />
    </DefaultLayout>
  );
}
